import { render, staticRenderFns } from "./round.vue?vue&type=template&id=a6804938"
import script from "./round.vue?vue&type=script&lang=js"
export * from "./round.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports